/* eslint-disable
    import/no-duplicates,
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
import { CUSTOMER_API, EVENT_API } from 'constants/ResourcesConstants'
import { getAuthorizationHeader } from 'utils/Helpers'
import { RequestContentType } from 'utils/Helpers'
import { serializeObject } from 'utils/Helpers'

const MetricAPI = Marty.createStateSource({
  id: 'MetricAPI',
  type: 'http',

  fetchMetrics(orgId) {
    return this.get({
      url: `${ CUSTOMER_API }/organizations/${ orgId }/metric_configurations`,
      headers: getAuthorizationHeader()
    })
  },

  fetchMetric(metricId, startDate, endDate) {
    const queryParams = serializeObject({
      startDate,
      endDate,
      periodType: 'DAY'
    })
    return this.get({
      url: `${ EVENT_API }/metrics/${ metricId }/contents?${ queryParams }`,
      headers: getAuthorizationHeader()
    })
  }
})

export default MetricAPI




// WEBPACK FOOTER //
// ./src/scripts/sources/MetricAPI.js